
export const debounceClickHook = {
  mounted(el: HTMLElement, binding: any) {
    let debounceTime = binding.value || 500;
    let timer: ReturnType<typeof setTimeout> | null = null;
    let isFirstClick = true; // 是否是第一次点击
    const clickHandler = function(event: Event) {
      // 如果不是第一次点击，阻止事件
      if (!isFirstClick) {
        event.stopImmediatePropagation();
        event.preventDefault();
      } else {
        // 第一次点击，允许执行
        isFirstClick = false;
      }

      // 清除之前的计时器
      if (timer) {
        clearTimeout(timer);
      }

      // 设置新的计时器，停止点击后重置状态
      timer = setTimeout(() => {
        isFirstClick = true;
        timer = null;
      }, debounceTime);
    };

    // 保存处理函数引用，用于清理
    (el as any)._debounceClickHandler = clickHandler;
    el.addEventListener('click', clickHandler, true);
  },

  unmounted(el: HTMLElement) {
    // 清理事件监听器，防止内存泄漏
    const handler = (el as any)._debounceClickHandler;
    if (handler) {
      el.removeEventListener('click', handler, true);
      delete (el as any)._debounceClickHandler;
    }
  },

  // 支持动态更新时间
  updated(el: HTMLElement, binding: any) {
    if (binding.value !== binding.oldValue) {
      const oldHandler = (el as any)._debounceClickHandler;
      if (oldHandler) {
        el.removeEventListener('click', oldHandler, true);
      }
      debounceClickHook.mounted(el, binding);
    }
  }
};
